import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSplit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSplit"><Path d="M2 6.5C2 5.11929 3.11929 4 4.5 4H10V20H4.5C3.11929 20 2 18.8807 2 17.5V6.5Z" fill="currentColor"/><Path d="M14 4H19.5C20.8807 4 22 5.11929 22 6.5V17.5C22 18.8807 20.8807 20 19.5 20H14V4Z" fill="currentColor"/><Path d="M11.5 2.5C11.5 2.22386 11.7239 2 12 2C12.2761 2 12.5 2.22386 12.5 2.5V21.5C12.5 21.7761 12.2761 22 12 22C11.7239 22 11.5 21.7761 11.5 21.5V2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSplit;
